import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import "./Campaign.scss";
import CampaignFull from "../../components/campaign/CampaignFull";
import CampaignDelete from "../../components/campaign/CampaignDelete";
import CampaignUpdate from "../../components/campaign/CampaignUpdate";
import CampaignAddXP from "../../components/campaign/CampaignAddXP";

const Campaign = () => {
  const { idCampaign } = useParams();
  const [campaign, setCampaign] = useState();
  const [isUpdate, setIsUpdate] = useState(false);
  const [isAddXP, setIsAddXP] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setIsUpdate(false);
    setIsAddXP(false);
    setIsDelete(false);
    setRefresh(false);
    setTimeout(() => {
      api
        .get(`/campaign/${idCampaign}/`)
        .then((response) => {
          setCampaign(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }, 500);
  }, [refresh]);

  return (
    <div className="campaign">
      {isLoading && (
        <div className="loading-data">
          <div className="loading-spinner"></div>
          <div className="loading-text">Chargement...</div>
        </div>
      )}
      {!isLoading && campaign == null && (
        <div className="no-data">
          <p>
            <strong>Campagne introuvable</strong>
          </p>
        </div>
      )}
      {!isLoading && campaign && (
        <>
          {isUpdate && (
            <>
              <CampaignUpdate
                campaign={campaign}
                setIsUpdate={setIsUpdate}
                setRefresh={setRefresh}
              />
            </>
          )}

          {isAddXP && (
            <>
              <CampaignAddXP
                campaign={campaign}
                setIsAddXP={setIsAddXP}
                setRefresh={setRefresh}
              />
            </>
          )}

          {isDelete && (
            <>
              <CampaignDelete campaign={campaign} setIsDelete={setIsDelete} />
            </>
          )}

          {!isUpdate && !isDelete && !isAddXP && (
            <>
              <CampaignFull
                campaign={campaign}
                setIsUpdate={setIsUpdate}
                setIsAddXP={setIsAddXP}
                setIsDelete={setIsDelete}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Campaign;
